'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024160 from "./presto.types$$anon$160.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Error-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$159() {
  this.cco = null;
  this.ccg = null;
  this.cch = false;
  this.ccp = null;
  this.ccq = false;
  this.cct = null;
  this.ccm = null;
  this.ccn = false;
  this.cci = null;
  this.ccj = false;
  this.cck = null;
  this.ccl = false;
  this.ccr = false;
  this.ccs = false;
  this.cco = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cct = "TwoFactorAuthErrorPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$159.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$159;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$159() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$159.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.cco;
});
$p.M = (function() {
  if ((!this.cch)) {
    this.ccg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cch = true;
  }
  return this.ccg;
});
$p.O = (function() {
  if ((!this.ccq)) {
    this.ccp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ccq = true;
  }
  return this.ccp;
});
$p.E = (function() {
  return this.cct;
});
$p.t = (function() {
  if ((!this.ccn)) {
    this.ccm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccn = true;
  }
  return this.ccm;
});
$p.N = (function() {
  if ((!this.ccj)) {
    this.cci = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ccj = true;
  }
  return this.cci;
});
$p.Q = (function() {
  if ((!this.ccl)) {
    this.cck = new $j_presto$002etypes$0024$0024anon$0024160.$c_Lpresto_types$$anon$160();
    this.ccl = true;
  }
  return this.cck;
});
$p.v = (function() {
  if ((!this.ccs)) {
    this.ccr = false;
    this.ccs = true;
  }
  return this.ccr;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee183) => ((p) => \u03b4scrutinee183.cG4(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthErrorPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$159, "presto.types$TwoFactorAuthPayload$$anon$159", ({
  a2L: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$159 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$159.js.map
